
import { defineComponent } from "@vue/runtime-core";
import { useStore } from "@/store";
import { mapActions, mapState } from "vuex";
import { mapMutations } from "vuex";
import { ID_COLUMN_SUFFIX } from "@/common/constant";

export default defineComponent({
  data() {
    return {
      hasError: false,
      selectedColumns: null,
    };
  },
  props: {
    workspaceId: {
      type: String,
    },
  },
  computed: {
    ...mapState("datasources", [
      "listRowData",
      "listHeader",
      "delimiter",
      "linebreak",
      "selectedDelimiter",
      "selectedLinebreak",
      "totalRow",
      "workbook",
    ]),
    worksheetNames(): string[] {
      return this.workbook.SheetNames.map((x: string) => ({ label: x }));
    },
  },
  created() {
    if (this.listRowData.length == 0) {
      return this.$router.push({
        path: `/workspace/${this.workspaceId}/datasource/create`,
      });
    }
    const booleanArray = this.listHeader.map(
      (element: any) =>
        this.checkIfStringHasSpecialChar(element.field) ||
        this.checkIfDuplicatedName(element.field)
    );
    if (booleanArray.includes(true)) {
      this.SET_PREVIEW_BUTTON(true);
      this.hasError = true;
    } else {
      this.SET_PREVIEW_BUTTON(false);
      this.hasError = false;
    }
    this.selectedColumns = this.listHeader.slice(0, 20);
  },
  setup() {
    const store = useStore();
    return { store };
  },
  methods: {
    ...mapMutations("datasources", [
      "SET_DELIMITER",
      "SET_LINEBREAK",
      "SET_SELECT_DELIMITER",
      "SET_SELECT_LINEBREAK",
      "SET_PREVIEW_BUTTON",
    ]),
    ...mapActions("datasources", ["changeWorksheet"]),
    checkIfStringHasSpecialChar(_string: string) {
      let spChars = /[`!%^&*()+=[\]{};':"\\|,.<>~\s]/;
      if (spChars.test(_string)) {
        return true;
      }
      return false;
    },
    checkIfDuplicatedName(_string: string) {
      const countHeader = this.listHeader.filter(
        (col: any) => _string === col.header
      );
      return countHeader.length > 1;
    },
    checkIfHasIdInName(_string: string) {
      let suffix = "";
      const hasSuffix = ID_COLUMN_SUFFIX.some((item) => {
        if (_string.substring(_string.length - 3).toLowerCase() === item) {
          suffix = _string.substring(_string.length - 3);
          return true;
        }
      });
      return hasSuffix ? suffix : undefined;
    },
    onTabChange({ index }: { originalEvent: Event; index: number }) {
      this.changeWorksheet(index);
      this.selectedColumns = this.listHeader.slice(0, 20);
    },
  },
});
